import { Component, computed, input, Input, OnInit } from '@angular/core';
import { Kpi, KpiTrend } from '../kpi-model';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { number } from 'mathjs';

@Component({
  selector: 'kpi-technicien',
  templateUrl: 'kpi-technicien.component.html',
  styleUrls: ['kpi-technicien.component.scss'],
  imports: [IonicModule, CommonModule, TranslateModule],
  standalone: true,
})
export class KpiTechnicienComponent implements OnInit {
  titre = input.required<string>();
  description = input.required<string>();
  kpi = input.required<Kpi>();
  objectif = input.required<number>();
  estObjectifAtteint = computed(() => {
    return this.kpi().pourcentage >= this.objectif();
  });

  isKpiValid = computed(() => {
    return (
      this.kpi().realise !== undefined &&
      this.kpi().realise !== null &&
      this.kpi().total !== undefined &&
      this.kpi().total !== null &&
      this.kpi().pourcentage !== undefined &&
      this.kpi().pourcentage !== null
    );
  });

  constructor(public translate: TranslateService) {}

  ngOnInit() {}
}
